import enabledDocumentTypesApi from "../../api/dte/enabledDocumentTypesApi";

const EnabledDocumentTypesService = {

  getAll: async () => {
    try {
      const response = await enabledDocumentTypesApi.fetchAll();
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  save: async (documentTypeId: number) => {
    try {
      const response = await enabledDocumentTypesApi.add({ documentTypeId });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  toggleStatus: async (id: number) => {
    try {
      const response = await enabledDocumentTypesApi.patchCustom(`${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EnabledDocumentTypesService;
